export default "__VITE_ASSET__ELYFuQGw__"